import PasswordStrengthMeter from '../PasswordStrengthMeter';

class FormWithPassword {
	#form;
	#passwordInput;
	
	constructor(form, params = {}) {
		this.#form = form;
		
		/** @type {HTMLInputElement} */
		this.#passwordInput = params.passwordInput || this.#getElement('.passwordInput');
	
		this.#initPasswordStrengthMeter(params.passwordProgressElement);
		this.#initEvents();
	}
	
	/**
	 * @param {HTMLElement | undefined} passwordProgressElement
	 */
	#initPasswordStrengthMeter(passwordProgressElement) {
		/** @type {PasswordStrengthMeter} */
		this.passwordStrengthMeter = new PasswordStrengthMeter({
			'passwordInput'          : this.#passwordInput,
			'passwordProgressElement': passwordProgressElement ?? this.#getElement('.passwordProgress')
		});
	}
	
	#initEvents() {
		// toggle password input value and toggle button texts
		const passwordInputParent = this.#passwordInput.parentElement,
			togglePasswordElement = passwordInputParent.querySelector('.togglePassword');

		if (togglePasswordElement) {
			togglePasswordElement.addEventListener(
			'click',
			() => {
				this.togglePasswordInputType(this.#passwordInput);
				this.updateToggleButtonTexts(passwordInputParent.querySelector('.showText'), passwordInputParent.querySelector('.hideText'));
				}
			);
		}

		// password validation
		this.#passwordInput.addEventListener(
			'change',
			() => {
				this.#validatePasswordInput();
				this.#passwordInput.addEventListener(
					'input',
					this.#validatePasswordInput.bind(this),
					{
						'passive': true
					}
				);
			},
			{
				'once': true
			}
		);
	}
	
	#validatePasswordInput() {
		const isValid = this.passwordStrengthMeter.isValidPassword(this.#passwordInput.value);

		this.#getElement(`.${this.#passwordInput.name}FrontendErrorMessage`).style.display = isValid ? 'none' : 'block';
		this.#passwordInput.classList.toggle('invalid', !isValid);
		this.#passwordInput.parentElement.classList.toggle('invalid', !isValid);
	}

	togglePasswordInputType(passwordInputTarget) {
		passwordInputTarget.type = passwordInputTarget.type === 'password'
			? 'text'
			: 'password';
	}

	updateToggleButtonTexts(passwordShow, passwordHide) {
		passwordShow.style.display = passwordShow.style.display === 'none'
			? 'block'
			: 'none';
		passwordHide.style.display = passwordHide.style.display === 'block'
			? 'none'
			: 'block';
	}
	
	/**
	 * @param {string} selector
	 * @returns {Element | HTMLInputElement}
	 */
	#getElement(selector) {
		return this.#form.querySelector(selector);
	}
	
	isPasswordValid() {
		return this.passwordStrengthMeter.isValidPassword(this.#passwordInput.value);
	}
}

export default FormWithPassword;